import React from 'react';
import { Box, Container } from '@mui/system';
import Header from './Header';
import MobileNavigation from './MobileNavigation';
import Footer from './Footer';

const Layout = ({ children }) => {
  return (
    <Box>
      <Header />
      <Container maxWidth='xl' component='div'>{children}</Container>
      <MobileNavigation />
      <Footer />
    </Box>
  );
};

export default Layout;
